export default __webpack_public_path__ + "static/media/van.f9223bb5.png";